import Admin from "../Admin";
import React from "react";
import CardAdminInsuranceSubTypeGeneral from "../../../Component/Card/Admin/InsuranceSubType/CardAdminInsuranceSubTypeGeneral";
import CardAdminInsuranceSubTypeOrganization from "../../../Component/Card/Admin/InsuranceSubType/CardAdminInsuranceSubTypeOrganization";
import CardAdminInsuranceSubTypeExternalIdentifiers from "../../../Component/Card/Admin/InsuranceSubType/CardAdminInsuranceSubTypeExternalIdentifiers";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUISaveButton from "@mui/icons-material/Save";
import MUILoadingButton from "@mui/lab/LoadingButton";
import Menu from "../../../Component/Menu";
import DialogConfirm from "../../../Component/Dialog/DialogConfirm";
import MUIMenuItem from "@mui/material/MenuItem";
import MUIListItemIcon from "@mui/material/ListItemIcon";

import Validator from "../../../Utility/Validator";

import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";
import InsuranceSubType from "../../../Utility/Crud/InsuranceSubType";
import insuranceService from "../../../Seating/Security/InsuranceService/insuranceService";
import Security from "../../../Utility/Security";

export default class AdminInsuranceSubTypeCreateEdit extends Admin {
  constructor(props) {
    super(props);

    this.state.insuranceSubType = null;
    this.state.isProcessing = false;
    this.state.isUpdate = !!props.match.params.id;
    this.state.confirmDialogOpen = false;
    this.state.validationIssues = {};
  }

  /**
   * Set the insurance subtype in the state.
   */
  afterComponentDidMount() {
    const insuranceSubTypeId = this.props.match.params.id
      ? +this.props.match.params.id
      : null;

    if (insuranceSubTypeId !== null) {
      const insuranceSubType =
        this.context.insuranceSubTypesIndexed[insuranceSubTypeId];
      this.setState({
        insuranceSubType: insuranceSubType,
      });
    }
  }

  /**
   * Creates the insurance subtype with the current properties in state.insuranceSubtype.
   */
  async createInsuranceSubType() {
    this.setState({
      isProcessing: true,
    });

    return insuranceService
      .createSubInsurance(this.state.insuranceSubType)
      .then((insuranceSubType) => {
        this.context.updateIndexed(
          "insuranceSubTypesIndexed",
          insuranceSubType,
        );
        this.props.history.goBack();
        NotistackEnqueueSnackbar("Insurance Subtype created successfully!", {
          variant: "success",
        });
      })
      .catch((err) => {
        console.log(err);
        NotistackEnqueueSnackbar(
          "Oh no! There was an error creating a new Insurance Subtype.",
          { variant: "error" },
        );
        this.setState({
          isProcessing: false,
        });
      });
  }

  /**
   * Updates the location with the current properties in state.location.
   */
  async updateInsuranceSubType() {
    this.setState({
      isProcessing: true,
    });

    return insuranceService
      .updateSubInsurance(this.state.insuranceSubType)
      .then((insuranceSubType) => {
        this.context.updateIndexed(
          "insuranceSubTypesIndexed",
          insuranceSubType,
        );
        this.props.history.goBack();
        NotistackEnqueueSnackbar("Insurance Subtype updated successfully!", {
          variant: "success",
        });
      })
      .catch((err) => {
        console.log(err);
        NotistackEnqueueSnackbar(
          "Oh no! There was an error updating the Insurance Subtype.",
          { variant: "error" },
        );
        this.setState({
          isProcessing: false,
        });
      });
  }

  async deleteInsuranceSubType() {
    this.setState({
      isProcessing: true,
    });

    return insuranceService
      .deleteInsuranceSubType(this.state.insuranceSubType.id)
      .then(() => {
        this.context.deleteIndexed(
          "insuranceSubTypesIndexed",
          this.state.insuranceSubType.id,
        );
        this.props.history.goBack();
        NotistackEnqueueSnackbar("Insurance Subtype deleted successfully!", {
          variant: "success",
        });
      })
      .catch((err) => {
        console.log(err);
        NotistackEnqueueSnackbar(
          "Oh no! There was an error deleting the Insurance Subtype.",
          { variant: "error" },
        );
        this.setState({
          confirmDialogOpen: false,
        });
      });
  }

  /**
   * Render the content.
   */
  renderContent() {
    const handleChange = (insuranceSubType) => {
      this.setState({
        insuranceSubType: {
          ...this.state.insuranceSubType,
          ...insuranceSubType,
        },
      });
    };

    return (
      <>
        <CardAdminInsuranceSubTypeGeneral
          insuranceSubType={this.state.insuranceSubType}
          onChange={handleChange.bind(this)}
          validationIssues={this.state.validationIssues}
        />
        <CardAdminInsuranceSubTypeOrganization
          insuranceSubType={this.state.insuranceSubType}
          onChange={handleChange.bind(this)}
          validationIssues={this.state.validationIssues}
        />
        <CardAdminInsuranceSubTypeExternalIdentifiers
          insuranceSubType={this.state.insuranceSubType}
          onChange={handleChange.bind(this)}
          validationIssues={this.state.validationIssues}
        />
        <DialogConfirm
          open={this.state.confirmDialogOpen}
          onClose={() => this.setState({ confirmDialogOpen: false })}
          onConfirm={() => this.deleteInsuranceSubType()}
          text="Are you sure you want to delete this insurance subtype? This cannot be undone."
          header="Delete Insurance Subtype"
          loading={this.state.isProcessing}
        />
      </>
    );
  }

  /**
   * Render the header.
   */
  renderHeader() {
    let title;
    let subtitle;
    const buttonText = this.state.isUpdate ? "Save" : "Create";

    if (!this.state.isUpdate) {
      title = "Create Insurance Subtype";
      subtitle = null;
    } else {
      title = "Edit Insurance Subtype";
      subtitle =
        this.state.location &&
        InsuranceSubType.getDisplayName(this.state.insuranceSubType) +
          " • " +
          this.state.insuranceSubType.id;
    }

    const handleClickBack = () => {
      this.props.history.goBack();
    };

    const handleClickSave = () => {
      const validationIssues = Validator.validate(this.state.insuranceSubType, {
        name: {
          required: true,
        },
        insuranceTypeId: {
          required: true,
        },
        insuranceSubTypeGroupTermId: {
          required: true,
        },
        pvPayorId: {
          type: "string",
        },
        brightreeExternalId: {
          type: "integer",
        },
      });

      this.setState({
        validationIssues: validationIssues,
      });

      if (Object.keys(validationIssues).length === 0) {
        if (this.state.isUpdate) {
          this.updateInsuranceSubType();
        } else {
          this.createInsuranceSubType();
        }
      } else {
        NotistackEnqueueSnackbar("Please correct the displayed issues.", {
          variant: "error",
        });
      }
    };

    const handleDelete = () => {
      this.setState({
        confirmDialogOpen: true,
      });
    };

    const buttons = [
      <MUIButton onClick={handleClickBack}>Back</MUIButton>,
      <MUILoadingButton
        loading={this.state.isProcessing}
        loadingPosition="start"
        onClick={handleClickSave}
        variant="contained"
        disabled={!Security.hasPermission("insuranceSubType.manage")}
        startIcon={<MUISaveButton />}
      >
        {buttonText}
      </MUILoadingButton>,
    ];

    if (this.state.isUpdate) {
      const menuItems = [
        <MUIMenuItem
          onClick={handleDelete}
          disabled={!Security.hasPermission("insuranceSubType.delete")}
        >
          <MUIListItemIcon>
            <MUIDeleteIcon fontSize="small" />
          </MUIListItemIcon>
          Delete
        </MUIMenuItem>,
      ];
      buttons.push(<Menu menuItems={menuItems} />);
    }

    return <PageHeader title={title} subtitle={subtitle} buttons={buttons} />;
  }
}
